module.exports = __webpack_public_path__ + "src/img/newfabu_on.b68bbceb.svg";